import { connect } from "react-redux";
import RawMaterialsBalancesScreen from "./RawMaterialsBalancesScreen";

export default connect((state) => {
  return {
    storehouse: state.storehouse.storehouse,
  };
})(RawMaterialsBalancesScreen);
